'use strict';

import React from 'react';
import Btn from './Btn';
import Shares from './Shares';
//require('styles//Footer.css');

class Footer extends React.Component {
  	render() {
    	return (
      		<footer>
                <Btn spots={this.props.spots} />
                <Shares />
      		</footer>
    	);
  	}
}

Footer.displayName = 'Footer';

// Uncomment properties you need
// FooterComponent.propTypes = {};
// FooterComponent.defaultProps = {};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js